module.exports = __webpack_public_path__ + "i18n/ko_cbb5727c5dee23a3fa54ecbf29e5672c.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_ko.properties
// module id = aSTO
// module chunks = 55